export const quoteMarkersVariants = {
  left: "left-0 -translate-x-1/2",
  right: "right-0 translate-x-1/2",
};
